import Repository from '../axios'

const resource = "/landlord";

export default {
  uploadBase64File(payload) {
    return Repository.post(`${resource}/file-upload-b64`, payload)
  },
};
